import { Pagination, PaginationProps } from 'antd';
import { ReactComponent as ArrowLeftIcon } from '@Icons/additional/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '@Icons/additional/arrow-right.svg';

interface MPaginationProps extends PaginationProps {
  pageSize?: number;
  currentPageValue?: number;
  totalItems?: number;
}

const customRenderArrow: PaginationProps['itemRender'] = (
  _,
  type,
  originalElement
) => {
  if (type === 'prev') {
    return <ArrowLeftIcon />;
  }
  if (type === 'next') {
    return <ArrowRightIcon />;
  }
  return originalElement;
};

const MPagination: React.FC<MPaginationProps> = (props) => {
  const { currentPageValue, totalItems } = props;

  return (
    <Pagination
      locale={{
        jump_to: 'Go to page',
        page: '',
      }}
      current={currentPageValue}
      total={totalItems}
      showTotal={(total) => `Total ${total} items`}
      itemRender={customRenderArrow}
      {...props}
    />
  );
};

export default MPagination;
